/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

type Pagination = { currentPage: number; pageSize: number };
type Search = {
  keywords?: string | number | unknown;
};
type Filter = Record<string, string | number | unknown>;
export const useLazyLoadOption = (props: {
  fetch: (
    pagination: Pagination,
    search?: Search,
    filter?: Filter
  ) => Awaited<any>;
  transformOption?: (record: any) => { value: string; label: string };
}) => {
  const [loading, setLoading] = React.useState(false);
  const [hasMore, setHasMore] = React.useState(true);
  const [data, setData] = React.useState<any[]>([]);

  const [pagination, setPagination] = React.useState<Pagination>({
    currentPage: 1,
    pageSize: 50
  });
  const [search, setSearch] =
    React.useState<
      Record<string, string | number | unknown | null | undefined>
    >();

  const [filter, setFilter] =
    React.useState<
      Record<string, string | number | unknown | null | undefined>
    >();
  const onFetch = async (
    nextPagination: Pagination,
    nextSearch: Search,
    nextFilter: Filter
  ) => {
    try {
      if (props.fetch) {
        setLoading(true);
        const response = await props.fetch(
          nextPagination,
          nextSearch,
          nextFilter
        );

        setData(response);
        setLoading(false);
      }
    } catch (error) {
      console.log('Lazy Dropdown error', error);
      setLoading(false);
    }

    return null;
  };

  const loadMore = async () => {
    if (loading || !hasMore) return;

    const nextPagination = {
      ...pagination,
      currentPage: pagination.currentPage + 1
    };
    setPagination(nextPagination);
    try {
      setLoading(true);
      const response = await props.fetch(nextPagination, search, filter);
      setData(data.concat(response));
      setHasMore(!!response.length);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onSearch = async (keyword: string) => {
    const nextSearch = {
      keywords: keyword
    };
    const nextPagination = {
      currentPage: 1,
      pageSize: 20
    };
    setPagination(nextPagination);
    setSearch(nextSearch);
    setHasMore(true);
    try {
      setLoading(true);
      const response = await props.fetch(nextPagination, nextSearch, filter);
      setHasMore(!!response.length);
      setData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onScroll = (e: any) => {
    if (
      e?.target?.scrollTop + e?.target?.offsetHeight >=
      e?.target?.scrollHeight - 50
    ) {
      loadMore();
    }
  };

  React.useEffect(() => {
    onFetch(pagination, search || {}, filter || {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loadMore,
    onSearch,
    onScroll,
    loading,
    hasMore,
    data
  };
};
